/**
 * WebComponents Initializer
 * Handles initialization logic when designsystem-webcomponents.js loads
 */
import type {} from './global'

// Initialize when document is loaded
function initializeWebComponents() {
  try {
    const managers = document.getElementsByTagName('ts-settings-manager')
    if (managers.length === 0) {
      document.body.insertAdjacentHTML('afterbegin', '<ts-settings-manager></ts-settings-manager>')
      document.AscendAwesome?.LogManager?.logDebug('<ts-settings-manager> added')
    }
    document.AscendAwesome?.LogManager?.logDebug('WebComponents initialized')
  } catch (e) {
    document.AscendAwesome?.LogManager?.logError('Error initializeWebComponents', e)
  }
}

// Run when document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWebComponents)
} else {
  // DOM is already loaded, run immediately
  initializeWebComponents()
}
